import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const KeyboardIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <rect
        x="2.5"
        y="6"
        width="19"
        height="12"
        rx="2"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M6 9.5H7M10 9.5H11M14 9.5H15M18 9.5H18.5M6 12.5H7M10 12.5H11M14 12.5H15M18 12.5H18.5M7.5 15.5H16.5"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

KeyboardIcon.displayName = 'KeyboardIcon';
